export default __webpack_public_path__ + "static/media/location_preview_diner.345d4e1c.svg";